import { useEffect, useState } from 'react';

// Tiny module-level pub-sub so any page can trigger the "view-only" warning
// toast without threading toast state through every component. Mount
// <EditAccessToastHost/> once, at the app root — every notifyEditBlocked()
// call anywhere in the app will show it.

let listeners = [];

export function notifyEditBlocked(message) {
  const text = message || 'You have view-only access — this action is disabled.';
  listeners.forEach(fn => fn(text));
}

export function EditAccessToastHost() {
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const handler = (text) => {
      setToast(text);
      setTimeout(() => setToast(null), 3200);
    };
    listeners.push(handler);
    return () => { listeners = listeners.filter(fn => fn !== handler); };
  }, []);

  if (!toast) return null;

  return (
    <div style={S.wrap}>
      <div style={S.toast}>{toast}</div>
    </div>
  );
}

const S = {
  wrap: {
    position: 'fixed', top: 20, left: '50%', transform: 'translateX(-50%)',
    zIndex: 9999, pointerEvents: 'none',
  },
  toast: {
    background: '#3A2A45', color: '#fff', padding: '12px 20px', borderRadius: 10,
    fontSize: 13.5, fontWeight: 500, fontFamily: "'Poppins', sans-serif",
    boxShadow: '0 8px 24px rgba(0,0,0,0.25)', maxWidth: 380, textAlign: 'center',
  },
};
